import React, { useEffect, useState } from 'react';
import './App.css';
import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';
import AdminPanel from './AdminPanel';

const ICONS = {
  Mojito: '🍹',
  Crepe: '🥞',
  Tea: '🍵',
  Lemon: '🍋',
  Cola: '🥤',
  Default: '🍸',
};

function getIcon(item, categories) {
  if (item.icon) return item.icon;
  const cat = categories.find(c => c.name === item.category);
  if (cat && cat.icon) return cat.icon;
  return '🍸';
}

function App() {
  const [menuItems, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch menu items and categories from Firestore
  const fetchData = async () => {
    try {
      // Fetch menu items
      const menuSnapshot = await getDocs(collection(db, 'menu'));
      const items = menuSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setMenuItems(items);
      // Fetch categories
      const catSnapshot = await getDocs(collection(db, 'categories'));
      const cats = catSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategories(cats);
    } catch (error) {
      setError('Failed to load menu or categories: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Filter out hidden items and categories
  const visibleItems = menuItems.filter(item => !item.hidden);
  const visibleCategories = categories.filter(cat => !cat.hidden);
  
  const groupedItems = visibleItems.reduce((groups, item) => {
    if (!groups[item.category]) {
      groups[item.category] = [];
    }
    groups[item.category].push(item);
    return groups;
  }, {});

  // Sort items by price (low to high) within each category
  Object.keys(groupedItems).forEach(category => {
    groupedItems[category].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
  });

  // Get categories in order (respecting the order field if it exists)
  const sortedCategories = visibleCategories
    .sort((a, b) => (a.order || 999) - (b.order || 999))
    .map(cat => cat.name);

  // Filter groupedItems to only include categories that exist in sortedCategories
  const orderedGroupedItems = {};
  sortedCategories.forEach(category => {
    if (groupedItems[category]) {
      orderedGroupedItems[category] = groupedItems[category];
    }
  });

  return (
    <div className="App" style={{position: 'relative', minHeight: '100vh'}}>
      <img src="/LogoBackground.svg" alt="Logo background" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        objectFit: 'cover',
        zIndex: -1,
        pointerEvents: 'none',
        opacity: 0.1
      }} />
      <header className="App-header">
        <h1 className="summer-title">The Bey Mojito</h1>
        <p className="subtitle">The Best of the Best</p>
      </header>
      <main>
        <section className="menu-section">
          <h2 className="menu-title">Menu</h2>
          {loading && <p>Loading menu...</p>}
          {error && <p className="error">{error}</p>}
          {!loading && !error && menuItems.length === 0 && (
            <p style={{textAlign: 'center', color: '#666', fontStyle: 'italic'}}>
              No menu items found. Add some items through the admin panel!
            </p>
          )}
          {!loading && !error && Object.keys(orderedGroupedItems).map(category => (
            <div key={category} className="menu-category-block">
              <h3 className="menu-category-title">{category}</h3>
              <div className="menu-list">
                {orderedGroupedItems[category].map(item => (
                  <div key={item.id} className="menu-item summer-card">
                    <div className="item-header-row">
                      <span className="item-icon">{getIcon(item, categories)}</span>
                      <span className="item-name">{item.name}</span>
                      <span className="item-price">{parseFloat(item.price).toFixed(2)} TND</span>
                    </div>
                    <span className="item-description">{item.description}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>
      </main>
      <footer className="footer">
        <div>Find us</div>
        <div className="footer-links">
          <a href="https://maps.app.goo.gl/xN1gfJmPFo4MEEKfA?g_st=ifm" target="_blank" rel="noopener noreferrer" title="Location">
            <svg className="footer-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="10" r="3.5" stroke="#ffe082" strokeWidth="2"/><path d="M12 22C14.5 19.5 20 14.36 20 10.5C20 6.36 16.42 3 12 3C7.58 3 4 6.36 4 10.5C4 14.36 9.5 19.5 12 22Z" stroke="#ff7043" strokeWidth="2"/></svg>
          </a>
          <a href="https://www.instagram.com/the_bey_mojito/" target="_blank" rel="noopener noreferrer" title="Instagram">
            <svg className="footer-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="5" stroke="#ff7043" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="#ffe082" strokeWidth="2"/><circle cx="17" cy="7" r="1.2" fill="#ff7043"/></svg>
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
